<template>
    <div class="content-container">
        <div class="top-content">
            <form @submit.prevent="CreateManualJournalEntryPreview()">
                <div class="grid-container">
                    <!--Market selection field -->
                    <label class="grid-item-left" for="market">Market</label>
                    <select id="market" class="dropdown invalid-input input-field-margin"  disabled >
                        <option> {{ MarketSelection.GB }} </option>
                    </select>

                    <!--Contract Owner Selector -->
                    <label class="grid-item-left" for="owner">Owner</label>
                    <select v-model="ownerSelection" class="form-input input-field-margin" required id="owner" >
                        <option v-for="contractOwner in contractOwners"
                            :value="contractOwner.OwnerId" 
                            :key="contractOwner.OwnerId" >
                            {{ contractOwner.FullName }}
                        </option>
                    </select>

                    <!--Journal Reference Toggle Field -->
                    <label class="grid-item-left">Journal Reference</label>
                    <GroupedInputButton class="button-group input-field-margin">
                        <button 
                        :class="journalReferenceTypeSelection == JournalReferenceType.AUTO_GENERATE?  'btn-not-selected default-btn left-btn' : 'default-btn left-btn'"
                        title="Select Journal Reference"
                        :disabled=working
                        @click="journalReferenceTypeSelection = JournalReferenceType.MANUAL"
                        type="button" >
                        Manual
                        </button>
                        <button title="Select Journal Reference"
                        :class="journalReferenceTypeSelection == JournalReferenceType.MANUAL?  'btn-not-selected default-btn left-btn' : 'default-btn left-btn'"
                        @click="journalReferenceTypeSelection = JournalReferenceType.AUTO_GENERATE"
                        type="button" >
                        Auto Generate
                        </button>
                    </GroupedInputButton>
                            
                    <!--Optional Manual Journal Reference Filed -->
                    <span v-if="journalReferenceTypeSelection == JournalReferenceType.MANUAL"/>
                    <input v-model="journalReference" v-if="journalReferenceTypeSelection == JournalReferenceType.MANUAL" class="form-input input-field-margin" type=text maxlength="64" placeholder="Manual Journal Reference" :required="journalReferenceTypeSelection == JournalReferenceType.MANUAL? true: false">
                            
                    <!--Accounting Date input field -->
                    <label class="grid-item-left" for="accountingDate">Accounting Date</label>
                    <div class="date-picker input-field-margin">
                        <DatePicker
                        type="date"
                        :enable-time-picker="false"
                        :format="FormatDatePicker"
                        placeholder="Select Accounting Date..."
                        :text-input-options="textInputOptions"
                        text-input
                        :teleport="true"
                        id="accountingDate"
                        v-model="accountingDate"
                        required
                        />
                    </div>

                    <!--Header Description input field -->
                    <label class="grid-item-left" for="headerDescription">Header Description</label>
                    <input v-model="headerDescription" class="form-input input-field-margin" type=text maxlength="200" placeholder="" id="headerDescription" required>
                        
                    <label class="line-item-separation-text" for="market">LINE ITEMS</label>
                        
                    <hr class="divider">

                    <!-- Journal line items -->
                    <div style="grid-column: span 2;">
                        <div v-for="(item, index) in journalLineItems" :key="index" class="grid-container">
                            <!-- Account input field -->
                            <label class="grid-item-left " :for="'account-' + index">Account</label>
                            <select v-model="item.Account" class="form-input input-field-margin" :id="'account-' + index" required>
                                <option v-for="option in accountOptions" :key="option.value" :value="option.value">
                                    {{ option.label }}
                                </option>
                            </select>
                            
                            <!-- Description input field -->
                            <label class="grid-item-left" :for="'description-' + index">Description</label>
                            <input v-model="item.Description" class="form-input input-field-margin" type="text" maxlength="255" :id="'description-' + index" placeholder="Enter Description" required>
                                        
                            <!-- Amount input field -->
                            <label class="grid-item-left" :for="'amount-' + index">Amount</label>
                            <CurrencyInput
                            v-model="item.Amount"
                            :min="0.01"
                            :step="0.01"
                            :currency="MarketCurrency[marketSelection]"
                            required
                            />

                            <label class="grid-item-left">Transaction Type</label>
                            <GroupedInputButton class="button-group input-field-margin">
                                <button 
                                :class="item.TransactionType === TransactionType.DEBIT ? 'default-btn left-btn' : 'btn-not-selected default-btn left-btn'"
                                title="Select Transaction Type"
                                type="button"
                                @click="item.TransactionType = TransactionType.DEBIT"
                                >
                                    Debit
                                </button>
                                <button 
                                :class="item.TransactionType === TransactionType.CREDIT ? 'default-btn right-btn' : 'btn-not-selected default-btn right-btn'"
                                title="Select Transaction Type"
                                type="button"
                                @click="item.TransactionType = TransactionType.CREDIT"
                                >
                                Credit
                                </button>
                            </GroupedInputButton>


                                    <!-- Tax Code input field -->
                            <label class="grid-item-left" :for="'taxCode-' + index">Tax Code</label>
                            <select v-model="item.TaxCode" class="form-input input-field-margin" :id="'taxCode-' + index" required>
                                <option v-for="option in taxCodeOptions" :key="option.value" :value="option.value">
                                    {{ option.label }}
                                </option>
                            </select>

                            <!-- Tax Return checkbox -->
                            <label class="grid-item-left" :for="'taxReturn-' + index">Include on Tax Return</label>
                            <input v-model="item.TaxReturn" type="checkbox" class="input-field-margin" :id="'taxReturn-' + index">

                            <!-- Divider spans both columns -->
                            <hr class="divider">
                        </div>
                    </div>

                    <div style="grid-column: span 2; display: flex; justify-content: center; gap: 10px;">
                        <button type="button" @click="AddLineItem" class="submit-btn line-item-btn">
                            ➕ Add Line Item
                        </button>

                        <button type="button" v-if="journalLineItems.length > 2" @click="RemoveLineItem" class="submit-btn line-item-btn">
                            ➖ Remove Line Item
                        </button>
                    </div>
                            
                    <div class="submit-btn-centre">
                        <button class="submit-btn" type="submit">
                            Preview Submission
                        </button>
                    </div>
                </div>
            </form>
        </div>
        
    </div>
    <ManualJournalPopUp v-model=manualJNLPopUp :previewData="previewData" :previewTable="previewTable"  @confirm="journalingPageRedirect" />
</template>

<script setup lang="ts">

import { computed, onBeforeMount, Ref, ref } from "vue";
import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import CurrencyInput from "@/components/CurrencyInput.vue";
import { defaultMarket, MarketCurrency, marketSelection, ownerSelection } from "@/services/helpers/Helper";
import { manualJournalingEnums } from "@/services/network";
import {  MarketSelection } from '@/services/helpers/Helper';
import IManualJournal from "@/Interfaces/Journaling/ManualJournal/IManualJournal";
import GroupedInputButton from "@/components/GroupedInputButton.vue";
import IManualJournalLineItems from "@/Interfaces/Journaling/ManualJournal/IManualJournalLineItems";
import IManualJournalingEnums from "@/Interfaces/Journaling/ManualJournal/IManualJournalingEnums";
import IManualJournalPreviewTable from "@/Interfaces/Journaling/ManualJournal/IPostManualJournalPreviewTable";
import ManualJournalPopUp from "@/components/ManualJournalPopUp.vue";
import router from "@/router";
import { RoutePaths } from "@/router/RouteDetails";
import { ContractOwner } from "@/models/CarPurchases/ContractOwner";
import { contractOwners as contractOwnersNetworkService } from "@/services/network";

enum JournalReferenceType {
    MANUAL = 'manual',
    AUTO_GENERATE = 'Auto Generate',
}
enum TransactionType {
    DEBIT = "debit",
    CREDIT = "credit"
}
const contractOwners = ref<ContractOwner[]>([]);
const manualJNLPopUp= ref(false);
const journalReference = ref("")
const accountingDate = ref<Date>()
const headerDescription = ref("")
const previewTable = ref<IManualJournalPreviewTable[]>([]);
const journalReferenceTypeSelection = ref(JournalReferenceType.MANUAL);
const textInputOptions = { format: "yyyy/MM/dd" };
const working = ref(false);
const preFetchedEnums = ref<IManualJournalingEnums>();
const previewData = ref<IManualJournal>({
    Market: "",
    JournalReference: "",
    AccountingDate: "",
    HeaderDescription: "",
    LineItems: [],
    OwnerID: ""
});
const journalLineItems: Ref<IManualJournalLineItems[]> = ref([
    {
        Account: "",
        Description: "",
        Amount: 0,
        TransactionType: TransactionType.CREDIT,
        TaxCode: "",
        TaxReturn: false,
    },
    {
        Account: "",
        Description: "",
        Amount: 0,
        TransactionType: TransactionType.DEBIT,
        TaxCode: "",
        TaxReturn: false,
    }
]);
const FormatDatePicker = (date: Date) => {
    return date.toLocaleString("sv-SE").split(" ")[0].replaceAll("-", "/");
};
const FormatDateSelection = (date: Date) => {
    return date.toLocaleString("sv-SE").split(" ")[0];
};
const taxCodeOptions = computed(() => {
    if (!preFetchedEnums.value?.TaxCodes){
        return [];
    } 
    return preFetchedEnums.value.TaxCodes.map(code => (
        {
            label: formatEnumValue(code),
            value: code
        }
    ));
});
const accountOptions = computed(() => {
    if (!preFetchedEnums.value?.Accounts){
        return [];
    } 
    return preFetchedEnums.value.Accounts.map(account => (
        {
            label: formatEnumValue(account),
            value: account
        }
    )).sort((a, b) => a.label.localeCompare(b.label));;
});
onBeforeMount(async() => {
    marketSelection.value = defaultMarket;
    await GetContractOwners()
    await GetAccountAndTaxCodeEnums()
})
async function GetContractOwners() {
    try {
        const res = await contractOwnersNetworkService.get()
        const data = res.data.filter( x => x.Market == marketSelection.value).sort((a, b) => {
                const aId = a?.OwnerId ?? "";
                const bId = b?.OwnerId ?? "";
                return bId.localeCompare(aId);
            });

        contractOwners.value = data;
        ownerSelection.value = contractOwners.value[0].OwnerId ?? "";
    } catch (error) {
        useNotifierWithErrFormatter().error({
            errorType: "Contract Owners",
            error,
        });
    }
}
function formatEnumValue (string: string){
    return string.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (word) => word.toUpperCase());
};
function AddLineItem(){
    journalLineItems.value.push({
        Account: "",
        Description: "",
        Amount: 0,
        TransactionType: TransactionType.DEBIT,
        TaxCode: "",
        TaxReturn: false,
    });
}
function RemoveLineItem(){
    journalLineItems.value.pop();
}
async function GetAccountAndTaxCodeEnums(){ 
    try{
        const response = await manualJournalingEnums.get()
        preFetchedEnums.value = response.data
    }catch(error){
        useNotifierWithErrFormatter().error({ error, errorType:"Failed to pre-fetch accout and tax code information"});
    }
}
async function CreateManualJournalEntryPreview() {
    previewData.value = {
        OwnerID: ownerSelection.value,
        Market: marketSelection.value,
        JournalReference: journalReferenceTypeSelection.value == JournalReferenceType.AUTO_GENERATE? "Auto Generated" : journalReference.value,
        AccountingDate: accountingDate.value? FormatDateSelection(accountingDate.value) :  "",
        HeaderDescription: headerDescription.value,
        LineItems: journalLineItems.value
    }
    previewTable.value = previewData.value.LineItems.map(
        lineItem => ({
            Account: lineItem.Account,
            Description: lineItem.Description,
            DebitAmount: lineItem.TransactionType === TransactionType.DEBIT ? lineItem.Amount : undefined,
            CreditAmount: lineItem.TransactionType === TransactionType.CREDIT ? lineItem.Amount : undefined,
            TaxCode: lineItem.TaxCode,
            TaxReturn: lineItem.TaxReturn
        })
    );

    manualJNLPopUp.value = true;
}
function journalingPageRedirect(){
    router.push({ path: RoutePaths.Journaling });
}
</script>

<style scoped lang="scss">
.grid-item-left {
    margin: auto 3px auto auto;
}
.grid-container {
    display: grid;
    grid-template-columns: 30% 70%;
    gap: 0.5rem;
    max-width: 1000px;
    margin: 0 auto;
}
.submit-btn {
    margin-top: 1rem;
    cursor: pointer;
    border-width: 0px;
    border-radius: var(--buttons-border-radius);
    background-color: var(--primary-color-lighter);
    padding: 10px;
    color: blue;
    font-size: larger;
    font-weight: bold;
    &:hover {
        color: white;
        background-color: var(--primary-color);
    }
}
.invalid-input:invalid {
    color: red; border-color: red; outline: none;
}
.submit-btn-centre {
    display: flex;
    justify-content: center;
    align-items: center;
    grid-column: span 2;
    margin-bottom: 20px;
}
:deep(.default-btn) {
    flex: 1;
    padding: 5px;
    font-size: 1em;
}
.btn-not-selected {
    background-color: white;
    color: black;
}
.divider {
    width: 100%;
    grid-column: span 2;
    border: 0;
    height: 1px;
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0));
}
.line-item-separation-text {
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    grid-column: span 2;
    margin-top: 1.2em;
}
.line-item-btn {
    font-size: 16px;
    width: 200px;
    margin-top: 2px;
}
.submit-btn:disabled {
    background-color: var(--light-grey);
    color: #b6b6b6;
    cursor: not-allowed;
}
.input-field-margin {
    margin-right: 30%;
}
:deep(.currency-input-container) {
    width: 70% !important;
}
:deep(.top-content) {
    margin-top: 20px;
}
::v-deep(#owner) {
    margin-right: 30%;
    width: 70%;
}
</style>